import { useMutation } from '@apollo/client';
import { ConfirmButton } from 'components/common/DefaultFormButton';
import { InputComponent } from 'components/common/Input';
import { INPUT_TYPE, LABEL_TYPE } from 'components/common/Input/types';
import { Form, Formik } from 'formik';
import React from 'react';
import { UPDATE_APPOINTMENT_ASSIGNMENT } from 'services/graphql/mutations/appointmentAssignments';
import { AssignmentStatus, IAssignment } from 'types/appointmentAssignments';
import { GeneralFunction } from 'types/common';
import { defaultNotification } from 'utils';

const CancelAppointmentForm: React.FC<{ assignment?: IAssignment; closeModal?: GeneralFunction }> = ({
  assignment,
  closeModal,
}) => {
  const [updateAssignment] = useMutation(UPDATE_APPOINTMENT_ASSIGNMENT);

  const cancelAppointment = async () => {
    if (!assignment) return;
    try {
      await updateAssignment({
        variables: {
          filter: {
            id: assignment.id,
          },
          updatedDoc: {
            status: AssignmentStatus.REJECTED,
          },
        },
      });
      defaultNotification({ success: 'Appointment cancelled!' });
      closeModal?.();
    } catch (err) {
      console.log('ERROR', err);
      defaultNotification({ failure: 'Something went wrong! Please try again' });
    }
  };
  return (
    <div>
      <Formik onSubmit={cancelAppointment} initialValues={{ reason: '' }}>
        <Form>
          <InputComponent
            name='reason'
            type={INPUT_TYPE.TEXT_AREA}
            label='Reason for cancelling the appointment (optional)'
            labelType={LABEL_TYPE.above}
          />
          <ConfirmButton width='auto' htmlType='submit'>
            Cancel Appointment
          </ConfirmButton>
        </Form>
      </Formik>
    </div>
  );
};
export default CancelAppointmentForm;
